export function Spinner({ label = 'Loading…' }: { label?: string }): JSX.Element {
  return (
    <div className="flex items-center gap-2.5 text-sm text-ink-500 dark:text-ink-400" role="status">
      <span className="h-4 w-4 animate-spin rounded-full border-2 border-ink-200 dark:border-white/10 border-t-brand-500" />
      <span className="font-medium text-ink-600 dark:text-ink-300">{label}</span>
    </div>
  );
}
